import "./Home.css";
import { useState } from "react";
import { ArrowRight, Briefcase, Check } from "react-feather";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import { FancyButton } from "../../commons/FancyButtons/FancyButtons";
import LangSwitch from "../../commons/LangSwitch/LangSwitch";
import logo from "../../../assets/leano/logo-c.png";
import routes from "../../../routes/routes";
import Typo from "../../commons/Typo/Typo";

// Home page
export default function Home() {
  const { t } = useTranslation(["common", "account"]);
  document.title = t("account:home.title");
  const navigate = useNavigate();
  const [activeButton, setActiveButton] = useState(false);

  return (
    <div className="Home">
      <header>
        <LangSwitch />
      </header>
      <main>
        <div className="Home-logo-wrapper">
          <img className="Home-logo" src={logo} alt="logo" />
        </div>
        <div className="Home-headings">
          <Typo variant="h1">{t("account:home.heading")}</Typo>
          <Typo variant="h2">{t("account:home.subheading")}</Typo>
        </div>
        <div className="HomeButtons">
          <FancyButton
            id="Login"
            heading={t("account:home.login.heading")}
            subheading={t("account:home.login.subheading")}
            icon={<Check />}
            iconConf={<ArrowRight />}
            onClick={() => navigate(routes.Account.Login)}
            primary={true}
            activeButton={activeButton}
            setActiveButton={setActiveButton}
            useHover
          />
          <FancyButton
            id="SignUp"
            heading={t("account:home.signup.heading")}
            subheading={t("account:home.signup.subheading")}
            icon={<Briefcase />}
            iconConf={<ArrowRight />}
            onClick={() => navigate(routes.Account.SignUp)}
            primary={false}
            activeButton={activeButton}
            setActiveButton={setActiveButton}
            useHover
          />
        </div>
      </main>
    </div>
  );
}
